
import {computeArcSegmentCount} from "./arcFromSagitta.js";

// Pure geometric core for the "Cirkel" tool. No DOM/THREE dependency -
// plain {x,y,z} points, Level 1 (no-browser) unit testable - see
// circleFromThreePoints.test.js.
//
// The circle itself is fully determined by a centre, radius and in-plane
// basis {u,v} - all THREE come from elsewhere in the capture flow (the
// user's own centre click + mouse-driven radius, and the point-cloud-
// estimated local plane - see tools/circleTool.js and
// geometry/localPlaneFit.js), so this module only needs the one shared
// sampling step below, adaptively tessellating a circle of a given radius
// into a closed ring of vertices.
export function sampleCirclePolygon(center, radiusM, {u, v}, toleranceM){
	const n = computeArcSegmentCount(radiusM, 2 * Math.PI, toleranceM);
	const points = new Array(n);
	for(let i = 0; i < n; i++){
		const angle = (2 * Math.PI * i) / n;
		const c = Math.cos(angle), s = Math.sin(angle);
		points[i] = {
			x: center.x + u.x * radiusM * c + v.x * radiusM * s,
			y: center.y + u.y * radiusM * c + v.y * radiusM * s,
			z: center.z + u.z * radiusM * c + v.z * radiusM * s,
		};
	}
	return {points, segmentCount: n};
}
